import { Illustration, Text } from "@clipboard-health/ui-components";
import { CardContent, Stack } from "@mui/material";
import { Button } from "@src/appV2/redesign/components/Button";

import { ShiftDetailsInnerCard } from "./InnerCard";

interface LateClockOutRulesCardProps {
  onViewWorkplacePolicies: () => void;
}

export function LateClockOutRulesCard(props: LateClockOutRulesCardProps) {
  const { onViewWorkplacePolicies } = props;

  return (
    <ShiftDetailsInnerCard
      footer={
        <Button fullWidth variant="outlined" size="medium" onClick={onViewWorkplacePolicies}>
          View workplace policies
        </Button>
      }
    >
      <CardContent>
        <Stack spacing={4} alignItems="center" sx={{ paddingX: 4, paddingY: 4 }}>
          <Illustration type="clock" />
          <Text semibold variant="h5" sx={{ textAlign: "center" }}>
            Late clock-out rules
          </Text>
          <Text
            variant="body2"
            sx={{ color: (theme) => theme.palette.text.secondary, textAlign: "center" }}
          >
            This workplace has specific rules for staying past your scheduled clock-out time.
          </Text>
        </Stack>
      </CardContent>
    </ShiftDetailsInnerCard>
  );
}
